
<template lang="jade">
	include ../../node_modules/tangram-ui/src/elements/tge-button/tge-button.jade
	include ../../node_modules/tangram-ui/src/elements/tge-componenttitle/tge-componenttitle.jade

	transition(appear, name="fade")
		.election-component.all-results(v-if="districts", :election-embed="embed")

			GroupTitle(v-if="title", :title="title", :year="year", :fineprint="percentCounted")

			.all-results_filter
				input.all-results_filter_input(placeholder="Search for your district", v-model.trim="searchValue")
				transition(appear, name="fade")
					+tge-button({
						text: 'Clear',
						icon: 'close',
						customClasses: ['all-results_filter_button'],
						customAttributes: { ':searchValue': 'searchValue', '@click': 'searchValue = null', 'v-if': 'searchValue' }
					})

			.tooltip(:style="tooltipStyles")
				template(v-if="tooltipData")
					.tooltip_close(@click="hideTooltip")
						+tge-svg-icons({ icon: "close" })
					DistrictDataTable(:district="tooltipData")
			//-.tooltip-overlay

			.election-component_content.all-results_content
				table.all-results_table(cellspacing="0")
					thead
						th.all-results_table_th.district_name(@click="onSort('')")
							.all-results_table_th_inner
								span.all-results_table_th_name|Name
								transition(appear, name="fade")
									template(v-if="sortValue")
										+tge-button({
											text: 'Reset sort',
											slim: true,
											icon: 'close',
											customAttributes: { ':searchValue': 'searchValue', '@click': 'sortValue = null' }
										})
						th.all-results_table_th(v-for="party in parties", :key="party['code']", :party="party['code']", :title="party['name']", @click="onSort(party['code'])", :class="{ sorted: sortValue === party['code'], ascending: sortAscending }" )
							.all-results_table_th_inner
								span.all-results_table_th_name {{ party['code'] }}
								span.all-results_table_th_icon
									transition(appear, name="fade")
										template(v-if="sortValue === party['code']")
											+tge-svg-icons({
												icon: 'arrow-down_outline'
											})

					transition-group(name="flip-list", tag="tbody")
						tr(v-for="district in sortedDistricts", :key="district['number']", :district-id="district['number']",
						@click="showTooltip(district, $event)", @mouseenter="showTooltip(district, $event)", @mousemove="moveTooltip", @mouseleave="hideTooltip($event, 'foo')")
							td.district_name {{ district['name'] }}
							td.district_party(v-for="party in parties", :key="party['code']")
								span.district_party_value(v-if="district.candidateMap && district.candidateMap[party['code']]")

									{{ district.candidateMap[party['code']].primaryVotes.percentage.toFixed(2) }}
</template>
<script>
	import DistrictDataTable from './DistrictDataTable.vue';
	import tooltipMixin from '../mixins/tooltip.js';
	import GroupTitle from './GroupTitle.vue';

	export default {
		name: "AllResults",
		mixins: [ tooltipMixin ],
		props: {
			title: {
				type: String
			},
			embed: {
				type: Boolean
			},
			year: {

			}
		},
		data: () => ({
			searchValue: null,
			sortValue: null,
			sortAscending: false,
		}),
		computed: {
			titleText() {
				console.log(this.year, this)
				return this.year ? `${this.year}: ${this.title}` : this.title;
			},
			districts() {
				return this.$store.getters.districts(this.year).map( ( district ) => {
					// Map array of candidates to an object with the party code as key
					const candidateMap = district.candidates.reduce( (acc, { party, ...candidate }) => {
						const currentDataForParty = acc[party] || {
							primaryVotes: {
								count: 0,
								percentage: 0.00
							}
						};

						acc[party] = {
							party,
							primaryVotes: {
								count: (currentDataForParty.primaryVotes.count + candidate.primaryVotes.count),
								percentage: (currentDataForParty.primaryVotes.percentage + candidate.primaryVotes.percentage)
							}
						};

						return acc;
					}, {});
					// return merged object.
					return {
						...district,
						candidateMap
					}
				});
			},
			visibleDistricts() {
				return this.searchValue ? this.districts.filter( (district) => {
					const regex = new RegExp(this.searchValue, "gi");
					return district['name'].match(regex);
				} ) : this.districts;
			},
			sortedDistricts() {
				return this.sortValue ? this.visibleDistricts.concat().sort((a, b) => {
					const pc1 = a.candidateMap[this.sortValue] && parseFloat(a.candidateMap[this.sortValue].primaryVotes.percentage, 10) || 0;
					const pc2 = b.candidateMap[this.sortValue] && parseFloat(b.candidateMap[this.sortValue].primaryVotes.percentage, 10) || 0;

					return this.sortAscending ? pc1 - pc2 : pc2 - pc1;
				}) : this.visibleDistricts;
			},
			parties() {
				return this.$store.getters.parties(this.year);
			},
			percentCounted() {
				const percentRollCounted = this.$store.getters.percentCounted(this.year);
				return percentRollCounted ? `${percentRollCounted}% counted` : null;
			}
		},
		mounted() {
			// console.log('this.$el', this.$el, this)
			this.tooltip = this.$el && this.$el.querySelector('.tooltip');
		},
		methods: {
			onSort(partyCode) {
				// If already sorted by this partCode, invert the sorting or set to default sort order
				this.sortAscending = this.sortValue === partyCode ? !this.sortAscending : false;
				this.sortValue = partyCode;
			}
		},
		components: {  DistrictDataTable, GroupTitle }
	}
</script>
<style lang="scss">
	@import "src/_commons/assets/scss/global-sass";
	@import 'node_modules/tangram-ui/src/elements/tge-button/tge-button';
	@import 'node_modules/tangram-ui/src/elements/tge-button/tge-button-dependencies';




	.all-results {
		text-align: left;
		max-width: 1000px;
		width: 100%;
		transition: opacity 0.3 0.3s ease;
		@include tgs-font-base-m;


		&[election-embed] {
			margin: $m-spacing-x4 auto;
			padding: 0 $m-spacing;
		}

		// line-height: 0.8rem;


		&.loading {
			transition-delay: 0;
			opacity: 0.5;
		}

		&_content {
			overflow: auto;
			padding: $m-spacing;
		}

		&_filter {
			padding: 0 $m-spacing $m-spacing-x2;
			display: flex;
			justify-content: flex-start; //center;

			&_input {
				height: 36px;
				padding: $m-spacing;
				width: 200px;
				border: 1px solid #aaa;
			}
			.tge-button { margin-left: $m-spacing; }
		}

		&_table {
			padding:0;
			width: 100%;

			&_th {
				font-weight: bold;  color: #666; width: 10%; cursor: pointer; padding: 0 #{$m-spacing / 2}; border-bottom:1px solid rgba(0,0,0,0.2);
				white-space: nowrap;
				&_inner { display: flex; align-items: center; border-top: 5px solid; padding: $m-spacing #{$m-spacing / 2}; height: 36px;}
				&.district_name &_inner {  border-color: white; }
				&_icon { flex: 0 0 20px; margin-left: $m-spacing; }

				.tge-button { margin-left: $m-spacing;  }
				.tge-svg-icon { transition: all 0.3s; width:20px; }

				&.sorted { font-weight:bold; }
				&.ascending .tge-svg-icon { transform: scaleY(-1); }

				&[party="LNP"] {
					.all-results_table_th_inner { border-color: $color-LNP; }
					path { fill: $color-LNP }
				}
				&[party="ALP"] {
					.all-results_table_th_inner { border-color: $color-ALP; }
					path { fill: $color-ALP }
				}
				&[party="GRN"] {
					.all-results_table_th_inner { border-color: $color-GRN; }
					path { fill: $color-GRN }
				}
				&[party="ZZZ"] {
					.all-results_table_th_inner { border-color: $color-IND; }
					path { fill: $color-IND }
				}
				&[party="KAP"] {
					.all-results_table_th_inner { border-color: $color-KAP; }
					path { fill: $color-KAP }
				}
				&[party="PUP"] {
					.all-results_table_th_inner { border-color: $color-OTH; }
					path { fill: $color-OTH }
				}
				&[party="ONP"] {
					.all-results_table_th_inner { border-color: $color-ONP; }
					path { fill: $color-ONP }
				}
				&[party="FFP"] {
					.all-results_table_th_inner { border-color: $color-FFP; }
					path { fill: $color-FFP }
				}
			}
		}

		tr {
			&:nth-child(odd) {
				background-color: #f5f5f5;
			}

			&:hover {
				background-color: rgba(0,0,0,0.2);
			}
		}

		td { color: currentColor; white-space: nowrap;  padding: $m-spacing; border-bottom: 1px solid #ccc; width: 10%; }

		.district_name { width: 20%; }

		.district_party_value {
			display: block;
			// padding: 3px $m-spacing;
		}
	}

	.flip-list-move {
		transition: transform 1s;
		pointer-events: none;
	}


</style>



// WEBPACK FOOTER //
// AllResultsTable.vue?e966221c